<template>
  <div class="vector-details" @keyup.enter="save()">
    <div class="prop">
      <div class="prop-key">
        {{ localization("app-uid", "UID") }}
      </div>
      <p class="prop-value is-medium-16-500-19">
        {{ feature.properties.uid }}
        <!-- <a><i class="fas fa-share-alt"></i></a> -->
      </p>
    </div>
    <div class="prop">
      <p class="prop-key" style="margin-bottom: 4px">
        {{ localization("app-issue-type", "Issue Type") }}
      </p>
      <p class="prop-value">
        <span class="button is-small" :style="{
          'border-color': this.vectors[feature.properties.class_id].color,
          'border-radius': '5px',
          'font-size': '14px',
        }">{{ this.vectors[feature.properties.class_id].description }}</span>
      </p>
    </div>
    <div class="prop">
      <p class="prop-key">
        {{ localization("app-string-number", "String Number") }}
      </p>
      <!-- <p class="prop-value"> -->
      <div v-if="!is_edit" :style="{
        'font-size': '14px',
        'font-family': 'Barlow',
        color: '#171e48',
      }">
        {{ featureObj.string_number || "NA" }}
      </div>
      <div class="field" v-if="is_edit">
        <div class="control">
          <input v-focus v-model="featureObj.string_number" v-if="is_edit" class="input is-small" type="text"
            :placeholder="localization('app-text-input', 'Text input')" />
        </div>
      </div>
      <!-- </p> -->
    </div>
    <div class="prop">
      <p class="prop-key">
        {{
          localization("app-modified-string-number", "Modified String Number")
        }}
      </p>
      <!-- <p class="prop-value"> -->
      <div v-if="!is_edit" :style="{
        'font-size': '14px',
        'font-family': 'Barlow',
        color: '#171e48',
      }">
        {{ featureObj.modified_string_number || "NA" }}
      </div>
      <div class="field" v-if="is_edit">
        <div class="control">
          <input v-focus v-model="featureObj.modified_string_number" v-if="is_edit" class="input is-small" type="text"
            :placeholder="localization('app-text-input', 'Text input')" />
        </div>
      </div>
      <!-- </p> -->
    </div>
    <div class="prop">
      <p class="prop-key">
        {{ localization("app-issue-description", "Issue Description") }}
      </p>
      <p class="prop-value is-medium-16-500-19">
        {{
          issue_description[
          this.vectors[feature.properties.class_id].class_name
          ]
        }}
      </p>
    </div>
    <div class="prop">
      <p class="prop-key">
        {{ localization("app-issue-timestamp", "Issue Timestamp") }}
      </p>
      <p class="prop-value">
        {{ feature.properties.timestamp || "NA" }}
      </p>
    </div>
    <div class="prop">
      <p class="prop-key">
        {{ localization("app-oordinates", "Coordinates") }}
      </p>
      <p class="prop-value">
        <a target="_blank" class="coordinates" :href="'https://www.google.com/maps/?t=h&z=25&q=' + center_reverse">{{
          center_reverse }}</a>
      </p>
    </div>
    <div class="prop">
      <p class="prop-key">
        {{ localization("app-comment", "Comment") }}
      </p>
      <p class="prop-value">
        <input v-model="featureObj.comment" v-if="is_edit" class="input is-small" type="text"
          :placeholder="localization('app-text-input', 'Text input')" />
        <span v-if="!is_edit" class="prop-value">{{
          featureObj.comment ||
          localization("app-not-available", "Not Available")
          }}</span>
      </p>
    </div>
    <div class="prop" style="display: flex; justify-content: space-between">
      <div>
        <p class="prop-key">
          &Delta; {{ localization("app-temperature", "Temperature") }}
        </p>
        <p class="prop-value is-medium-16-500-19">
          <!-- <span class="tag" style="background:red"> -->
          {{ String(feature.properties.temperature_difference).substr(0, 5) }}
          °C
          <!-- </span> -->
        </p>
      </div>
      <div v-if="stc_data">
        <p class="prop-key">
          STC {{ localization("app-temperature", "Temperature") }}
        </p>
        <p class="prop-value">
          <a @click="$root.$emit('show_graph')">{{ String(stc_data.stc_temperature).substr(0, 5) }} °C</a>
        </p>
      </div>
    </div>

    <div>
      <div style="position: absolute; right: 10px; top: 10px">
        <a v-if="!is_edit" class="btn-edit is-small" @click="is_edit = !is_edit">
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a v-if="is_edit" class="button btn-cancel is-small" @click="is_edit = !is_edit">
          <i class="fas fa-times"></i>
        </a>
        <a v-if="is_edit" :class="{
          'is-loading': is_loading,
          'is-info': !is_saved,
          'is-success': is_saved,
        }" class="button btn-save is-small" @click="save()">
          <i class="fas" :class="{ 'fa-save': !is_saved, 'fa-check': is_saved }"></i>
        </a>
      </div>
      <div>
        <ebs-create-ticket :feature="feature"></ebs-create-ticket>
      </div>
    </div>
  </div>
</template>
<script>
import EbsCreateTicket from "./ebs-create-ticket.component";
import { mapGetters, mapMutations, mapState } from "vuex";
import ApiService from "../../../../api.service";
const apiService = new ApiService();

export default {
  components: { EbsCreateTicket },
  props: ["feature"],
  data: function () {
    return {
      is_edit: 0,
      featureObj: {
        comment: "",
        string_number: "",
        modified_string_number: "",
      },
      center: "",
      center_reverse: "",
      is_loading: false,
      is_saved: false,
      issue_description: {
        hotspot:
          "An area of elevated temperature affecting only a cell/portion of a module.",
        diode_failure:
          "Overheating of a single string of cells within a module.",
        module_failure:
          "Overheating of an entire module when compared to the neighboring modules.",
        module_reverse_polarity:
          "A checkerboard type heat signature on a single module when multiple cells are affected.",
        string_failure:
          "Overheating of an entire string of modules when compared to neighboring strings.",
        string_reverse_polarity:
          "A checkerboard type heat signature on a string of modules.",
      },
    };
  },
  created() {
    this.center = this.feature.properties.center[0].join(",");
    this.center_reverse = this.feature.properties.center[0].reverse().join(",");
    this.featureObj = {
      comment: this.feature.properties.comment || "",
      string_number: this.feature.properties.string_number || "",
      modified_string_number:
        this.feature.properties.modified_string_number || "",
    };
  },
  computed: {
    ...mapState([
      "active_layer",
      "vectors",
      "token",
      "api_host",
      "draw",
      "temp_data",
      "active_layers",
    ]),
    stc_data() {
      return this.temp_data.find((e) => e.uid === this.feature.properties.uid);
    },
  },
  watch: {
    feature(val) {
      if (val) {
        this.center = this.feature.properties.center[0].join(",");
        this.featureObj = {
          comment: this.feature.properties.comment || "",
          string_number: this.feature.properties.string_number || "",
          modified_string_number:
            this.feature.properties.modified_string_number || "",
        };
      }
    },
  },
  methods: {
    ...mapMutations(["UPDATE_ACTIVE_LAYERS"]),
    save() {
      this.is_loading = true;
      apiService
        .post(`internal/bulk/features?viewUid=${this.$route.params.uid}`, [
          {
            issueUID: this.feature.properties.uid,
            ...this.featureObj,
          },
        ])
        .then((res) => {
          this.draw.setFeatureProperty(
            this.feature.id,
            "comment",
            this.featureObj.comment
          );
          this.draw.setFeatureProperty(
            this.feature.id,
            "string_number",
            this.featureObj.string_number
          );
          this.draw.setFeatureProperty(
            this.feature.id,
            "modified_string_number",
            this.featureObj.modified_string_number
          );
          let active_layers = { ...this.active_layers };
          let features =
            active_layers[this.feature.properties.projectUid].features;
          features = features.map((f) => {
            if (f.id == this.feature.id)
              return {
                ...f,
                properties: { ...f.properties, ...this.featureObj },
              };
            return f;
          });
          active_layers[this.feature.properties.projectUid].features = features;
          this.UPDATE_ACTIVE_LAYERS(active_layers);
          this.is_edit = !this.is_edit;
          this.is_loading = false;
          this.is_saved = true;
          this.is_saved = !this.is_saved;
        })
        .catch((err) => {
          this.is_edit = false;
          this.$toast.open("Could not save the changes.");
          this.handleErrors(err);
          this.is_loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.vector-details {
  padding: 1rem 1.2rem;
  font-family: Barlow;

  .prop {
    margin-bottom: 1.5rem;
  }

  .prop-key,
  .prop-value {
    font-size: 14px;
    font-family: Barlow-medium;

    a {
      color: #5c7ef7;
      text-decoration: underline;
    }
  }

  .prop-key {
    font-size: 12px;
    opacity: 0.5;
    color: #171e48;
  }

  .prop-value {
    font-weight: 500;
  }

  .btn-cancel {
    margin-right: 0.5rem;
  }

  .tag {
    color: white;
    font-weight: bold;

    .fa {
      margin-right: 5px;
    }
  }
}
</style>
